

jQuery(document).ready(function () {

    //sticky header
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 50) {
            jQuery('.header').addClass('sticky-header');
        } else {
            jQuery('.header').removeClass('sticky-header');
        }
    });


    jQuery('.btn-view').on('click', function (e) {
        e.preventDefault();
        jQuery('.see-more-content').toggleClass('active');
        if (jQuery('.see-more-content').hasClass('active')) {
            jQuery(this).find('a span').text('See Less');
        } else {
            jQuery(this).find('a span').text('See More');
        }
    })

   jQuery('.about-more').on('click', function (e) {
        e.preventDefault();
        jQuery('.about-more-content').toggleClass('active');
        if (jQuery('.about-more-content').hasClass('active')) {
            jQuery(this).find('a span').text('See Less');
        } else {
            jQuery(this).find('a span').text('See More');
        }
    })

  jQuery('.read-more').on('click', function (e) {
        e.preventDefault();
        const btn = jQuery(this).parent().find('.product-list')
        btn.toggleClass('active');
        if (btn.hasClass('active')) {
            jQuery(this).text('Read Less');
        } else {
            jQuery(this).text('Read More');
        }
    })

  // Product Slider Main
    const partner_ = jQuery('#partner-logo');
    partner_.owlCarousel({
        loop:true,
        margin:10,
        nav:false,
        dots:true,
        margin:35,
        autoplay:false,
        autoplayTimeout:1500,
        autoplayHoverPause:false,
        responsive:{
            0:{
                items:2
            },
            600:{
                items:3
            },
            1000:{
                items:4
            }
        }
    })

    const owl_feature = jQuery('#product-featured-v2');

    owl_feature.owlCarousel({
        loop:false,
        margin:10,
        nav:true,
        dots:false,
        margin:15,
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:false,
        responsive:{
            0:{
                items:2
            },
            600:{
                items:3
            },
            1000:{
                items:4
            }
        }
    })


  //Hide Product Price

  
});


jQuery(window).on('load',function(){

  var interval = window.setInterval(function(){

        jQuery('.scError').text('');
        jQuery('.scError').html('Incorrect ID Code - email us at <a href="mailto:support@vedicinals.com">support@vedicinals.com</a> for help');
    
  }, 250);

  if(jQuery('#create_customer').find('h1').text().length > 1) {
   jQuery(document.body).find(`main .secondary-h1`).hide();
}   

jQuery('.pop-select').on('change', function(){
   window.location = jQuery(this).val();
});




jQuery('.mobile-inner .nav-item-has-child .iconify').on('click', function(){
    jQuery(this).parent().toggleClass('sub-active');
});
  

})


